import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(auth)/login/page.tsx");
